import React, { useState } from 'react';
import { useThroughputData } from '../hooks/useThroughputData';
import { FilterBar } from '../components/throughput/FilterBar';
import { KPIStrip } from '../components/throughput/KPIStrip';
import { ThroughputFunnel } from '../components/throughput/ThroughputFunnel';
import { LeadSourceBreakdown } from '../components/throughput/LeadSourceBreakdown';
import { LoanOfficerTable } from '../components/throughput/LoanOfficerTable';
import { LeadSource } from '../types/throughput';
import { Loader2, ChevronRight } from 'lucide-react';
export function ThroughputDashboard() {
  const {
    isLoading,
    filters,
    setFilters,
    metrics,
    companyAverages,
    officers,
    filteredLeads,
    filteredOpportunities
  } = useThroughputData();
  const [showSourceBreakdown, setShowSourceBreakdown] = useState(false);
  const handleRefresh = () => {
    window.location.reload();
  };
  const handleRowClick = (officerId: string) => {
    if (filters.scopeType === 'Loan Officer' && filters.selectedScopeId === officerId) {
      setFilters({
        ...filters,
        scopeType: 'All',
        selectedScopeId: undefined
      });
    } else {
      setFilters({
        ...filters,
        scopeType: 'Loan Officer',
        selectedScopeId: officerId
      });
    }
  };
  const handleSourceClick = (source: LeadSource) => {
    if (filters.leadSources.length === 1 && filters.leadSources[0] === source) {
      setFilters({
        ...filters,
        leadSources: []
      });
    } else {
      setFilters({
        ...filters,
        leadSources: [source]
      });
    }
  };
  if (isLoading || !metrics) {
    return <div className="min-h-screen flex items-center justify-center bg-[#F5F5F5]" data-id="element-172">
        <div className="flex flex-col items-center gap-3" data-id="element-173">
          <Loader2 className="h-6 w-6 animate-spin text-[#7C3AED]" data-id="element-174" />
          <p className="text-sm text-[#706E6B]" data-id="element-175">Loading dashboard…</p>
        </div>
      </div>;
  }
  return <div className="min-h-screen bg-[#F5F5F5]" data-id="element-176">
      <FilterBar filters={filters} setFilters={setFilters} officers={officers} onRefresh={handleRefresh} data-id="element-177" />

      <main className="max-w-[1600px] mx-auto px-6 py-8" data-id="element-178">
        {/* Page Header */}
        <div className="mb-8" data-id="element-179">
          <p className="text-[11px] font-semibold uppercase tracking-widest text-[#7C3AED] mb-1.5" data-id="element-180">
            Zoom Home Lending
          </p>
          <h1 className="text-2xl font-semibold text-[#181818]" data-id="element-181">
            Throughput Dashboard
          </h1>
          <p className="text-sm text-[#706E6B] mt-1" data-id="element-182">
            Cohort analysis of lead conversion performance
          </p>
        </div>

        <KPIStrip metrics={metrics} data-id="element-183" />

        <ThroughputFunnel metrics={metrics.funnelMetrics} data-id="element-184" />

        {/* Lead Source Toggle */}
        <button onClick={() => setShowSourceBreakdown(!showSourceBreakdown)} className="flex items-center gap-1.5 text-sm font-medium text-[#706E6B] hover:text-[#7C3AED] mb-4 transition-colors group" data-id="element-185">
          <ChevronRight className={`h-4 w-4 transition-transform duration-200 ${showSourceBreakdown ? 'rotate-90' : ''}`} data-id="element-186" />
          Lead Source Breakdown
        </button>

        {showSourceBreakdown && <LeadSourceBreakdown leads={filteredLeads} opportunities={filteredOpportunities} onSourceClick={handleSourceClick} selectedSource={filters.leadSources.length === 1 ? filters.leadSources[0] : null} data-id="element-187" />}

        <LoanOfficerTable metrics={metrics.officerMetrics} companyAverages={filters.scopeType === 'Loan Officer' && filters.selectedScopeId ? companyAverages : null} onRowClick={handleRowClick} data-id="element-188" />
      </main>
    </div>;
}